import { render } from "./TvmAppointmentAddress.vue?vue&type=template&id=56a7e726&scoped=true"
import script from "./TvmAppointmentAddress.vue?vue&type=script&lang=js"
export * from "./TvmAppointmentAddress.vue?vue&type=script&lang=js"

import "./TvmAppointmentAddress.vue?vue&type=style&index=0&id=56a7e726&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a7e726"],['__file',"src/Components/ChatWidget/SlideOutPanel/TvmAppointmentAddress/TvmAppointmentAddress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56a7e726"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56a7e726', __exports__)) {
    api.reload('56a7e726', __exports__)
  }
  
  module.hot.accept("./TvmAppointmentAddress.vue?vue&type=template&id=56a7e726&scoped=true", () => {
    api.rerender('56a7e726', render)
  })

}


export default __exports__